export const EMPTY_PLACEHOLDER = '-----';

// NOTE: antd needs a non-undefined filteredValue to treat a column filter as not controlled by it.
export const CLEANUP_WHEN_EMPTY = null;
